import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is ChildCheck compliant with Ohio DCY licensing rules?",
    a: "Yes. ChildCheck is built around Ohio Administrative Code 5101:2-12 for centers and 5101:2-13 for family homes. All required forms (DCY 01234, DCY 01236, DCY 01217, DCY 01250, DCY 01276, DCY 01299, CCU-202, CCU-204) are pre-configured and audit-exportable.",
  },
  {
    q: "How does the live ratio monitoring work?",
    a: "Staff clock in via the Staff App. Children check in via the Parent App or front-desk kiosk. ChildCheck continuously computes the ratio for each room against OAC 5101:2-12-18 Appendix A and sends a push alert before a ratio breaks.",
  },
  {
    q: "Do you migrate our existing records?",
    a: "Yes. Our Ohio onboarding team handles the data migration — children, families, staff, active enrollment forms, and payment methods — typically over a weekend. You keep operating during the switch.",
  },
  {
    q: "Can parents pay tuition through ChildCheck?",
    a: "Yes — via Stripe (ACH + card). Automatic late fees, subsidy reconciliation, and scheduled invoicing are supported on the Growth plan.",
  },
  {
    q: "Is my center's data secure?",
    a: "Yes. Data is encrypted in transit (TLS 1.3) and at rest (AES-256). We are SOC 2 ready and use HIPAA-grade practices for child health information (DCY 01236, DCY 01217).",
  },
  {
    q: "What happens after the 14-day free trial?",
    a: "You keep your data. If you choose to subscribe, pick a plan and pay monthly — no setup fees. If not, export your records and go.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-emerald-700">
            Questions
          </div>
          <h2 className="mt-4 font-display text-4xl sm:text-5xl font-medium text-stone-900 tracking-tight">
            The ones directors ask first.
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-12 divide-y divide-stone-200 border-y border-stone-200">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-0">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-6 text-left font-display text-lg font-medium text-stone-900 hover:no-underline hover:text-emerald-800"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-stone-600 leading-relaxed text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
